export function runAfterInteractions(callback: () => void) {
  const timeout = setTimeout(callback, 0);

  return () => {
    clearTimeout(timeout);
  };
}
